import { Button, Col, Row } from 'antd';
import { useIntl } from 'react-intl';

type FileLoading = {
  PDF?: boolean;
  REPORT_VIEW?: boolean;
  HTML?: boolean;
  CSV?: boolean;
};
interface Props {
  viewReport?: () => void;
  generatePdf?: () => void;
  generateCsv?: () => void;
  loading?: FileLoading;
}
const ButtonsToGenerateReports: React.FC<Props> = ({
  viewReport,
  generatePdf,
  generateCsv,
  loading,
}) => {
  const intl = useIntl();
  return (
    <Col>
      <Row gutter={[20, 12]}>
        {!!viewReport && (
          <Col span={24} md={8} lg={6} xxl={4}>
            <Button
              block
              type="primary"
              onClick={viewReport}
              key="viewReport"
              loading={loading?.REPORT_VIEW}
            >
              {intl.formatMessage({ id: 'reports.button.viewReport' })}
            </Button>
          </Col>
        )}

        {!!generatePdf && (
          <Col span={24} md={8} lg={5} xxl={3}>
            <Button
              block
              type="primary"
              onClick={generatePdf}
              key="PDF"
              loading={loading?.PDF}
            >
              {intl.formatMessage({ id: 'reports.button.pdf' })}
            </Button>
          </Col>
        )}

        {!!generateCsv && (
          <Col span={24} md={8} lg={5} xxl={3}>
            <Button
              block
              type="primary"
              onClick={generateCsv}
              key="CSV"
              loading={loading?.CSV}
            >
              {intl.formatMessage({ id: 'reports.button.csv' })}
            </Button>
          </Col>
        )}
      </Row>
    </Col>
  );
};

export default ButtonsToGenerateReports;
